import { Txt } from '@vst/beam';
import { useTranslation } from 'react-i18next';

import { CustomStandardModal } from '@app/components/Modal';

import styles from '../../styles/configure-voice.module.scss';

interface E911IncorrectAddressModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const E911IncorrectAddressModal = ({ isOpen, onClose }: E911IncorrectAddressModalProps) => {
  const { t } = useTranslation('ShopAddons');

  return (
    <div data-cy={'e911-incorrect-address-modal'}>
      <CustomStandardModal
        size={'medium'}
        header={t('voice.emergencyScrubbedAddress.incorrectModal.title')}
        isOpen={isOpen}
        onClose={onClose}
        actions={{
          primary: {
            label: t('voice.emergencyScrubbedAddress.incorrectModal.primaryButton.label'),
            onClick: onClose,
          },
        }}
        surfaceProps={{ className: styles['incorrect-address-modal'] }}
      >
        <Txt variant={'bodySmallRegular'} style={{ margin: '0px' }}>
          {t('voice.emergencyScrubbedAddress.incorrectModal.description')}
        </Txt>
      </CustomStandardModal>
    </div>
  );
};
